<template>
  <div>
    <section class="SubMenu tw-bg-gradient2-lr tw-py-6">
      <div class="ns-container">
        <h1 class="heading-white tw-text-center">
          Chat Explorer
        </h1>
      </div>
    </section>

    <section>
      <div class="tw-w-screen tw-p-2">
        <autocomplete-search
          api="/api/admin/profiles/search"
          :options="{
            placeholder: 'Search profiles',
            noResult: 'No profiles matching'
          }"
          :custom-label="(option) => `${option.nickname} (${option.name})`"
          @onSelect="onSelect"
        />
      </div>
    </section>

    <div
      v-if="chatrooms.length > 0"
      class="tw-flex tw-flex-col"
    >
      <section class="submenu tw-bg-gradient2-lr tw-text-white tw-flex tw-fixed tw-w-full">
        <div
          class="tw-flex-shrink-0 tw-flex tw-items-center tw-py-3 md:tw-w-4/12 xl:tw-w-3/12"
          :class="{ 'sidebar-active-full': sidebarActive, 'sidebar-inactive': !sidebarActive }"
        >
          <div
            :class="{ 'tw-hidden': !sidebarActive }"
            class="sidebar-button-close tw-cursor-pointer"
            @click="chatFilter = ''"
          >
            <i class="fas fa-times" />
          </div>
          <div class="sidebar-button-search tw-hidden md:tw-block">
            <i class="fas fa-search" />
          </div>
          <router-link
            :to="navigate('chat')"
            :class="{ 'tw-hidden': sidebarActive }"
            class="sidebar-button-menu md:tw-hidden"
          >
            <i class="fas fa-bars" />
          </router-link>

          <input
            v-model="chatFilter"
            type="text"
            class="sidebar-search sidebar-search-full"
            :class="{'tw-hidden':!sidebarActive}"
            placeholder="Search"
          >
        </div>
        <div
          v-if="typeof $route.params.chatroomId !== 'undefined'"
          class="chat-section chat-section-header"
        >
          <div class="tw-flex tw-items-center">
            <router-link :to="`/profile/${chatroom.user.profile}`">
              <img
                :src="`${$api}${chatroom.user.mainPicture.thumb}`"
                class="chat-section-header-image"
              >
            </router-link>
            <div>
              <h3 class="tw-text-lg tw-font-bold">
                {{ chatroom.user.nickname }}, {{ chatroom.user.age }}
              </h3>
              <span class="tw-hidden sm:tw-block tw-text-xs">{{ chatroom.user.profession }}</span>
            </div>
          </div>
          <button
            v-if="showSyncButton"
            class="btn-circle btn-circle-lg btn-circle-teal tw-shadow tw-text-xl"
          >
            <i class="fas fa-sync-alt" />
          </button>
        </div>
      </section>
      <div class="">
        <section
          class="tw-flex tw-pt-22 tw-pb-10 md:tw-pb-0"
          :style="`height: calc(100vh - ${isMobile ? 117 : 96}px)`"
        >
          <div
            class="tw-flex-shrink-0 tw-h-full tw-overflow-y-auto md:tw-w-4/12 xl:tw-w-3/12"
            :class="sidebarActive ? 'sidebar-active-full' : 'sidebar-inactive'"
          >
            <ChatListItem
              v-for="filteredChatroom in filteredChatrooms"
              :key="filteredChatroom.id"
              :active="$route.params.chatId === filteredChatroom.id"
              :sidebar-active="sidebarActive"
              :chatroom="filteredChatroom"
            />
          </div>
          <ChatLog
            v-if="chatroom.id > 0"
            :key="`chatroom-${chatroom.id}`"
            :sidebar-active="sidebarActive"
            :chatroom="chatroom"
          />
        </section>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from 'vue';

import { sync } from 'vuex-pathify';

import Chatroom from '@/vuex/orm/models/Chatroom';

export default {
  name: 'PageChat', // important

  components: {
    ChatLog: () => import('@/components/chat/ChatLog'),
    ChatListItem: () => import('@/components/chat/ChatListItem'),
  },

  data() {
    return {
      chatroom: {
        id: 0,
      },
      chatrooms: [],
      // sidebarActive: true,
      activeChats: [],
      // activePeers: {},
      chatsAreLoading: true,
      typingTimer: false,
      showSyncButton: false,
    };
  },

  computed: {
    ...sync([
      'chat/limit', //
      'chat/chatFilter', //
      'chat/activePeers',
      'chat/activeChatId',
      'device/isMobile',
    ]),

    sidebarActive() {
      return typeof this.$route.params.chatroomId === 'undefined';
    },

    filteredChatrooms() {
      return this.chatrooms.filter((chatroom) => {
        // console.log('chatroom', chatroom);
        switch (true) {
          case chatroom.user.nickname.toLowerCase().includes(this.chatFilter.toLowerCase()):
            return true;
          // case chatroom.type === 'private' && chatroom.user.nickname.toLowerCase().includes(this.chatFilter.toLowerCase()):
          // return true;
          // case chatroom.type === 'group' && chatroom.label.toLowerCase().includes(this.chatFilter.toLowerCase()):
          // return true;
          default:
            return false;
        }
      });
    },

    hasChatrooms() {
      return this.chatrooms.length > 0;
    },

    chatHeader() {
      if (!this.hasChatrooms && this.chatsAreLoading) {
        return 'Your chats are loading...';
      }
      return 'You are not part of any chats yet';
    },
  },

  watch: {
    $route: {
      handler() {
        if (['chat', 'chatroom'].includes(this.$route.name)) {
          this.loadChatrooms();
        }
      },
      immediate: true,
    },
  },

  created() {
    this.registerBusEventListeners();

    Bus.$on('chatrooms:refreshed', () => {
      this.loadChatrooms();
    });
  },

  beforeDestroy() {
    Bus.$off('chatrooms:refreshed');
    Bus.$off('read:chatroom');
    Bus.$off('echo:join:chatroom');
  },

  methods: {
    loadChatrooms() {
      this.chatrooms = Chatroom.query()
        .orderBy('lastMessageTs', 'desc')
        .get();
      // console.log('swipe.chatrooms', this.chatrooms);

      // console.log('chatroom.count', this.chatrooms.length);
      // console.log('chatrooms.first', this.chatrooms[0]);

      if (this.chatrooms.length > 0) {
        this.determineActiveChatroomId();
        this.chatsAreLoading = false;
      }

      Bus.$emit('loading', false);
    },

    // onSidebarToggle() {
    //   this.sidebarActive = !this.sidebarActive;
    // },

    determineActiveChatroomId() {
      if (typeof this.$route.params.chatroomId !== 'undefined') {
        this.chatroom = Chatroom.find(parseInt(this.$route.params.chatroomId, 10));

        Bus.$emit('echo:join:chatroom', this.chatroom.id);
        // Bus.$emit('load:messages', this.chatroom.id, this.limit);
      } else if (this.isMobile === false) {
        // If not on mobile, we load most recent chat so we don't have a big blank screen
        this.chatroom = Chatroom.query()
          .where('lastMessageAt', (value) => value !== null)
          .orderBy('lastMessageAt', 'desc')
          .first();

        this.$router.push(this.navigate(`chat/${this.chatroom.id}`));
      }
    },

    readChatroom(chatroomId) {
      // console.log('reading chatroom', chatroomId);

      // this.$root.markNotificationsAsRead();

      Bus.$emit('notifications:mark-as-read');

      this.$http.post(`/api/chat/${chatroomId}/read`, {}).then(() => {
        // console.log('chat.readChatroom', response.data);
      });
    },

    registerBusEventListeners() {
      // Bus.$on('load:chatroom', (chatroomId) => {
      //   this.loadChatroom(chatroomId);
      // });

      Bus.$on('read:chatroom', (chatroomId) => {
        this.readChatroom(chatroomId);
      });

      Bus.$on('echo:join:chatroom', (chatroomId) => {
        // ensures user only joins the chatroom once
        if (!this.activeChats.includes(chatroomId)) {
          // console.log('chat.created.bus.echo:join:chatroom.activeChats', this.activeChats);
          // console.log('chat.created.bus.echo:join:chatroom', chatroomId);

          Vue.set(this.activePeers, chatroomId, {
            peerIsTyping: false,
          });

          window.Echo.join(`chatroom.${chatroomId}`)
            .here((users) => {
              this.usersInRoom = users;
            })
            .joining((user) => {
              this.usersInRoom.push(user);
            })
            .leaving((user) => {
              this.usersInRoom = this.usersInRoom.filter((u) => u !== user);
            })
            .listen('.MessagePosted', (e) => {
              // console.log('echo.MessagePosted', e);
              if (e.user_id !== this.$auth.user().id) {
                // console.log('chat.echo:join:chatroom.MessagePosted', e);

                Bus.$emit('load:messages', chatroomId, this.limit);

                Vue.set(this.activePeers, chatroomId, {
                  peerIsTyping: false,
                });
              }
            });

          // console.log(`chatroom.${chatroomId}.listenForWhisper`);

          window.Echo.private(`chatroom.${chatroomId}`).listenForWhisper('typing', (e) => {
            // console.log(`chatroom.${chatroomId}.whisper`, e);
            Vue.set(this.activePeers, chatroomId, {
              peerIsTyping: e,
            });

            if (this.typingTimer) clearTimeout(this.typingTimer);

            this.typingTimer = setTimeout(() => {
              Vue.set(this.activePeers, chatroomId, {
                peerIsTyping: false,
              });
            }, 1500);
          });
        }
      });
    },
  },
};
</script>

<style>
.sidebar-search {
  @apply tw-text-base tw-py-2 tw--ml-2 tw-mr-10 tw-bg-transparent tw-border-b tw-border-custom-white-15 tw-outline-none;
}

.sidebar-search-half {
  @apply tw-w-48;
}

.sidebar-search-full {
  @apply tw-w-full;
}

.sidebar-search::placeholder {
  @apply text-custom-midgray2;
}

.sidebar-button-close {
  @apply tw-mx-8 tw-px-0 tw-text-3xl;
}

.sidebar-button-menu {
  @apply tw-mx-auto tw-px-0 tw-text-3xl;
}

.sidebar-inactive {
  @apply tw-w-20;
}

.sidebar-active-full {
  @apply tw-w-full;
}

.sidebar-active-half {
  @apply tw-w-72;
}

.chat-section-header {
  @apply tw-w-auto tw-flex-grow tw-flex-shrink-0 tw-flex tw-items-center tw-justify-between tw-bg-custom-white-15 tw-h-full tw-py-3 tw-px-3;
}

.chat-section-header-image {
  @apply tw-my-2 tw-h-12 tw-w-12 tw-mr-2 tw-flex-shrink-0 tw-rounded-full tw-border-2 tw-border-custom-midgray2;
}

@screen sm {
  .chat-section-header {
    @apply tw-px-5;
  }

  .chat-section-header-image {
    @apply tw-h-16 tw-w-16 tw-mr-5;
  }
}
@screen md {
  .chat-section-header-image {
    @apply tw-my-0;
  }

  .sidebar-search {
    @apply tw-block tw-w-full;
  }

  .sidebar-button-close {
    @apply tw-mx-auto tw-px-5 tw-hidden;
  }

  .sidebar-button-menu {
    @apply tw-px-5;
  }

  .sidebar-button-search {
    @apply tw-mx-auto tw-px-5 tw-text-3xl;
  }
}
</style>
